<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25 5H7a2 2 0 00-2 2v19a1 1 0 002 0v-1h8v1a1 1 0 002 0V13h8v13a1 1 0 002 0V7a2 2 0 00-2-2zM15 7v4H7V7zM7 23v-4h8v4zm8-6H7v-4h8zm2-6V7h8v4z"/><path d="M12.5 20.5h-3a.5.5 0 000 1h3a.5.5 0 000-1z"/></svg>